import React, { createContext, useMemo, useState, useTransition } from 'react';
import { useLocation } from 'react-router-dom';
import useSWR from 'swr';

import fetcher from 'services/fetcher';

import { MEETING_TYPES } from 'constants/types';
import { PUBLIC_ROUTES } from 'constants/routes';

const FindExpertContext = createContext({});

const DEFAULT_FILTERS = {
  travel_destination: '',
  scheduling_type: MEETING_TYPES.online,
  page: 0,
  limit: 8,
  size: 8,
};

export function FindExpertProvider({ children }) {
  const [isPending, startTransition] = useTransition();
  const { pathname } = useLocation();
  const { data, isLoading, error } = useSWR('topic', fetcher, {
    revalidateOnFocus: false,
    refreshInterval: 0,
    revalidateOnReconnect: false,
  });

  const [filters, setFilters] = useState(DEFAULT_FILTERS);

  const onChangeFilter = (filters) => {
    startTransition(() => {
      setFilters((prev) => ({
        ...prev,
        ...filters,
        page: 0,
      }));
    });
  };

  const getMoreData = () => {
    startTransition(() => {
      setFilters((prev) => ({
        ...prev,
        page: prev.page + 1,
      }));
    });
  };

  const resetFilters = () => {
    startTransition(() => {
      setFilters(DEFAULT_FILTERS);
    });
  };

  const value = useMemo(
    () => ({
      filters,
      isPending,
      isSearchPage: pathname === PUBLIC_ROUTES.SEARCH_TRAVEL_EXPERT,
      searchPage: PUBLIC_ROUTES.SEARCH_TRAVEL_EXPERT,
      topics: data,
      topicsError: error,
      topicsLoading: isLoading,
      onChangeFilter,
      getMoreData,
      resetFilters,
    }),
    [data, isLoading, error, filters, isPending, pathname]
  );

  return (
    <FindExpertContext.Provider value={value}>
      {children}
    </FindExpertContext.Provider>
  );
}

export const useFindExpert = () => React.useContext(FindExpertContext);
